/* eslint-disable react/no-unescaped-entities */
import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Image } from "@src/components/Image";
import { getAwsAssets, hitHapticFeedback } from "@src/utils";

import { showApplyCouponBottomSheetAction } from "@src/components/BottomSheets/store/actions";
import {
  applyCourseCouponAction,
  removeCourseCouponAction,
  setCouponCodeAction,
} from "@src/components/Tabs/Overview/store/actions";
import { useRouter } from "@src/lib/router";
import { t } from "i18next";
import { newWebEngage } from "@src/utils/webEngageEvent";

import Button from "@src/components/UIElements/Button/index";
import RightArrowIcon from "@src/components/AccentIcons/RightArrowIcon";
import formatCouponExpiryDateTime from "@src/utils/formatCouponExpiryDateTime";

const Coupon = ({
  pricingSections,
  getCourseCouponListStudentDataServer,
}) => {
  const router = useRouter();

  const dispatch = useDispatch();

  const graphCouponListData = useSelector((state) => {
    if (state?.overviewReducer?.graphCourseCouponListData?.coupons?.length) {
      return state?.overviewReducer?.graphCourseCouponListData;
    }
    return getCourseCouponListStudentDataServer;
  });

  const graphCouponList = graphCouponListData?.coupons;

  // console.log("A_______1", graphCouponListData);
  // console.log("A_______2", getCourseCouponListStudentDataServer);
  // console.log("A_______3", graphCouponList);

  let studentCouponList = graphCouponList ? [...graphCouponList] : [];

  const handleCouponApply = (coupon, i, close) => {
    dispatch(
      applyCourseCouponAction({
        variables: {
          courseId: router.query.courseId,
          code: coupon?.code,
        },
      })
    );

    dispatch(setCouponCodeAction({ coupon }));

    if (close) {
      handleShowModal(false);
    }
  };

  const handleCouponRemove = (coupon) => {
    sessionStorage.removeItem("APPLIEDCOUPON");
    dispatch(
      removeCourseCouponAction({
        variables: {
          code: coupon.code,
          redemptionId: appliedCoupon.redeemId,
        },
      })
    );
  };

  let setTimeoutRef = useRef();
  useEffect(() => {
    return () => {
      stopCountdown();
    };
  }, []);

  const stopCountdown = () => {
    clearInterval(setTimeoutRef.current);
  };

  const appliedCoupon = useSelector(
    (state) => state?.overviewReducer?.graphCourseData?.appliedCoupon
  );

  return (
    <div
      className={!pricingSections ? "couponsDiv" : "couponsDivPricingSection"}
    >
      <div className="CouponTop blockSlide">
        <div
          className="Label"
          style={{ fontSize: pricingSections ? "14px" : "16px" }}
        >
          {t(
            "components.tabs.overview.components.coupons.index.availableOffersText",
            "Available Offers"
          )}
        </div>
        {studentCouponList && studentCouponList.length > 3 ? (
          <Button
            className="viewALLBtnMobile"
            onClick={() => {
              // handleShowModal(true);
              newWebEngage("course_coupons_list_view", {
                action: "Coupon Code Viewed",
              });
              hitHapticFeedback();
              dispatch(showApplyCouponBottomSheetAction(true));
            }}
            style={{ marginRight: !pricingSections ? "16px" : "0px" }}
            // outline
          >
            {t(
              "components.tabs.overview.components.coupons.index.viewAllText",
              "View All"
            )}
            <RightArrowIcon />
          </Button>
        ) : (
          ""
        )}
      </div>
      <div className="CouponBottom blockSlide">
        {studentCouponList &&
          studentCouponList.map(({ coupon }, i) => {
            if (i < 3) {
              const expiryText = formatCouponExpiryDateTime(coupon?.endDateTime);

              return (
                <div
                  key={i}
                  className={
                    coupon.code == appliedCoupon?.code
                      ? pricingSections
                        ? "coupon couponAppliedCustom"
                        : "coupon couponApplied"
                      : pricingSections
                      ? "coupon couponCustom"
                      : "coupon"
                  }
                  onClick={() => {
                    hitHapticFeedback();
                    if (coupon.code == appliedCoupon?.code) {
                      handleCouponRemove(coupon);
                    } else {
                      handleCouponApply(coupon, i);
                    }
                    //applyCoupon
                  }}
                >
                  <div
                    className={
                      expiryText
                        ? "couponIconCol"
                        : "couponIconCol couponIconColCenter"
                    }
                  >
                    {coupon.code == appliedCoupon?.code ? (
                      <Image
                        src={getAwsAssets("couponApplied.svg", "Overview")}
                        className="SVGCoupons"
                        height="24"
                        width="24"
                      />
                    ) : (
                      <Image
                        src={getAwsAssets("couponUnappliead.svg", "Overview")}
                        className="SVGCoupons"
                        height="20"
                        width="20"
                      />
                    )}
                    {expiryText && (
                      <span className="couponExpiryIcon">⚠️</span>
                    )}
                  </div>
                  <div style={{ marginLeft: "12px" }}>
                    <div className="couponLabel">{coupon?.code}</div>
                    <div className="couponName">{coupon?.label}</div>
                    {expiryText && (
                      <div className="couponExpiry">
                        {t(
                          "components.tabs.overview.components.coupons.index.expiresOnText",
                          "Expires on"
                        )}{" "}
                        {expiryText}
                      </div>
                    )}
                  </div>
                </div>
              );
            }
          })}
      </div>
    </div>
  );
};

export default React.memo(Coupon);
